const API_BASE_URL = process.env.REACT_APP_API_URL;

export async function createBooking(bookingData) {
  
  try {
    const response = await fetch(`${API_BASE_URL}/api/bookings`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(bookingData),
    });


    if (!response.ok) {
      const error = await response.json();
      console.error('API Call - Error response:', error);
      throw new Error(error.error || 'Failed to create booking');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('API Call - Fetch error:', error);
    throw error;
  }
}

export async function getBookingById(bookingId) {
  
  try {
    const response = await fetch(`${API_BASE_URL}/api/bookings/${bookingId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });


    // Check if response is HTML (server error page)
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('text/html')) {
      console.error('API Call - Received HTML response instead of JSON');
      throw new Error('Server connection error. Please ensure the backend server is running on port 5000.');
    }

    if (!response.ok) {
      let errorMessage = 'Failed to get booking';
      try {
        const error = await response.json();
        console.error('API Call - Get booking error response:', error);
        errorMessage = error.error || errorMessage;
      } catch (parseError) {
        console.error('API Call - Failed to parse error response:', parseError);
        errorMessage = `Server error (${response.status})`;
      }
      throw new Error(errorMessage);
    }

    let result;
    try {
      result = await response.json();
      return result;
    } catch (parseError) {
      console.error('API Call - Failed to parse success response:', parseError);
      throw new Error('Invalid server response format');
    }
  } catch (error) {
    console.error('API Call - Get booking fetch error:', error);
    
    // Provide user-friendly error messages
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      throw new Error('Unable to connect to server. Please check if the backend is running.');
    }
    
    throw error;
  }
}

export async function updateBooking(bookingId, bookingData) {
  
  try {
    const response = await fetch(`${API_BASE_URL}/api/bookings/${bookingId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(bookingData),
    });


    // Check if response is HTML (server error page)
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('text/html')) {
      console.error('API Call - Received HTML response instead of JSON');
      throw new Error('Server connection error. Please ensure the backend server is running on port 5000.');
    }

    if (!response.ok) {
      let errorMessage = 'Failed to update booking';
      try {
        const error = await response.json();
        console.error('API Call - Update booking error response:', error);
        errorMessage = error.error || errorMessage;
      } catch (parseError) {
        console.error('API Call - Failed to parse error response:', parseError);
        errorMessage = `Server error (${response.status})`;
      }
      throw new Error(errorMessage);
    }

    let result;
    try {
      result = await response.json();
      return result;
    } catch (parseError) {
      console.error('API Call - Failed to parse success response:', parseError);
      throw new Error('Invalid server response format');
    }
  } catch (error) {
    console.error('API Call - Update booking fetch error:', error);
    
    // Provide user-friendly error messages
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      throw new Error('Unable to connect to server. Please check if the backend is running.');
    }
    
    throw error;
  }
}


